import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { campaignReportsActions } from 'store/actions';
import { AppsBudgetDropDown, ChartArrowDown, ChartArrowUp } from 'assets/icons';
import { Loader, ParagraphWithTooltip } from 'components';

import * as S from './StatisticBtnDynamic.styled';

export const StatisticBtnDynamic = ({
  values,
  color,
  metric,
  isFetchingPrevDataChart,
  changeList,
  numOfDays,
  numOfTabs = 1,
  currentEventInd,
  isChartHidden,
  selectedMetrics,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const isSelected = selectedMetrics[metric];
  const labelList = Object.values(values).map((el) => el.label);
  const valueList = Object.values(values).map((el) => el.value);

  const dispatch = useDispatch();

  function handleClick(e, isChartHidden) {
    if (isChartHidden) return;
    if (e.target.closest('.dropdown-trig') && isSelected && labelList?.length > 1) return;
    if (e.target.closest('.dropdown')) return;
    const newValue = { ...selectedMetrics };
    newValue[metric] = !newValue[metric];

    dispatch(
      campaignReportsActions.updateProperty({
        propField: 'selectedMetricsCampaignReports',
        newValue: newValue,
      }),
    );
  }

  function handleOpenDropDown(e) {
    if (e.target?.closest('.dropdown') || isChartHidden) return;
    if (labelList?.length < 2) return;

    setIsOpen((state) => !state);
    if (!isOpen) {
      window.addEventListener('click', (e) => closeDropDown(e, true), { once: true });
      window.addEventListener('scroll', () => setIsOpen(false), { once: true });
    }
  }

  function handleEventChange(ind) {
    if (ind !== currentEventInd) {
      dispatch(
        campaignReportsActions.updateProperty({
          propField: 'currentEventInd',
          newValue: ind,
        }),
      );
    }
    setIsOpen(false);
  }

  function closeDropDown(e, isInitial) {
    if (isInitial) {
      setIsOpen(true);
      window.addEventListener('click', (e) => closeDropDown(e, false), { once: true });
      return;
    }

    if (e.target?.closest('.dropdown') && !e.target?.closest('.dropdown-item')) {
      window.addEventListener('click', (e) => closeDropDown(e, false), { once: true });
      return;
    } else {
      setIsOpen(false);
    }
  }

  return (
    <S.OuterContainer
      onClick={(e) => handleClick(e, isChartHidden)}
      isChartHidden={isChartHidden}
      numOfTabs={numOfTabs}
    >
      <S.TopLine color={color} isSelected={isSelected} isChartHidden={isChartHidden}></S.TopLine>
      <S.Container isSelected={isSelected} isChartHidden={isChartHidden}>
        <S.LabelWrap>
          <S.DynamicLabel isActive={isOpen}>
            <S.LabelTextWrap
              className='dropdown-trig'
              isActive={isOpen}
              onClick={handleOpenDropDown}
            >
              <S.LabelText isActive={isOpen} isSelected={isSelected} isChartHidden={isChartHidden}>
                <ParagraphWithTooltip text={labelList[currentEventInd]} />
              </S.LabelText>
              {labelList?.length > 1 && (
                <S.ArrowWrap isOpen={isOpen}>
                  <AppsBudgetDropDown />
                </S.ArrowWrap>
              )}
              {isOpen && isSelected && (
                <S.LabelDropDown className='dropdown'>
                  {labelList.map((label, ind) => (
                    <S.DropDownItem
                      className='dropdown-item'
                      key={label}
                      isSelected={true}
                      isChartHidden={isChartHidden}
                      isActive={ind === currentEventInd}
                      onClick={() => handleEventChange(ind)}
                    >
                      {label}
                    </S.DropDownItem>
                  ))}
                </S.LabelDropDown>
              )}
            </S.LabelTextWrap>
          </S.DynamicLabel>
          <S.AnimatedIconButton color={color}></S.AnimatedIconButton>
        </S.LabelWrap>
        <S.DataWrap>
          <S.Value>{valueList[currentEventInd]}</S.Value>
          <S.RightContainer>
            <S.SmallText>vs last {numOfDays}d</S.SmallText>
            <S.ChangeContainer change={changeList[currentEventInd]}>
              {isFetchingPrevDataChart ? (
                <S.PrevLoaderWrap>
                  <Loader.Local delay={0} />
                </S.PrevLoaderWrap>
              ) : (
                <>
                  {changeList[currentEventInd] < 0 && <ChartArrowDown />}
                  {changeList[currentEventInd] > 0 && <ChartArrowUp />}
                  <div>
                    {changeList[currentEventInd]
                      ? `${Math.abs(changeList[currentEventInd].toFixed(2))}%`
                      : '0'}
                  </div>
                </>
              )}
            </S.ChangeContainer>
          </S.RightContainer>
        </S.DataWrap>
      </S.Container>
    </S.OuterContainer>
  );
};
